"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_FILTER_BY = exports.CLEAR_TOOLBAR_FILTERS = exports.SET_JUMP_TO_DATE = exports.JUMP_TO_DATE = exports.SET_TOOLBAR_FILTERS = exports.GO_BACK = exports.KEEP_ORIGINAL_APPOINTMENT = exports.RESCHEDULING_APPOINTMENT_FAILED = exports.RESCHEDULE_APPOINTMENT = exports.UPDATE_REASON = exports.RESCHEDULED = exports.UPDATE_APPT_QUERY = exports.LOAD_MORE = exports.SELECT_APPOINTMENT = exports.LOADING_ERROR = exports.LOADING_DONE = exports.RESCHEDULE = void 0;
exports.RESCHEDULE = '@event/RESCHEDULE';
exports.LOADING_DONE = '@event/LOADING_DONE';
exports.LOADING_ERROR = '@event/LOADING_ERROR';
exports.SELECT_APPOINTMENT = '@event/SELECT_APPOINTMENT';
exports.LOAD_MORE = '@event/LOAD_MORE';
exports.UPDATE_APPT_QUERY = '@event/UPDATE_APPT_QUERY';
exports.RESCHEDULED = '@event/RESCHEDULED';
exports.UPDATE_REASON = '@event/UPDATE_REASON';
exports.RESCHEDULE_APPOINTMENT = '@event/RESCHEDULE_APPOINTMENT';
exports.RESCHEDULING_APPOINTMENT_FAILED = '@event/RESCHEDULING_APPOINTMENT_FAILED';
exports.KEEP_ORIGINAL_APPOINTMENT = '@event/KEEP_ORIGINAL_APPOINTMENT';
exports.GO_BACK = '@event/GO_BACK';
exports.SET_TOOLBAR_FILTERS = '@event/SET_TOOLBAR_FILTER';
exports.JUMP_TO_DATE = '@event/JUMP_TO_DATE';
exports.SET_JUMP_TO_DATE = '@event/SET_JUMP_TO_DATE';
exports.CLEAR_TOOLBAR_FILTERS = '@event/CLEAR_TOOLBAR_FILTERS';
exports.UPDATE_FILTER_BY = '@event/UPDATE_FILTER_BY';
//# sourceMappingURL=Events.js.map